module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifRegularItalic.ebd8a977.woff";